import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/layouts/AdminLayout";
import EmployeeLayout from "@/components/layouts/EmployeeLayout";
import Login from "@/pages/Login";

import AdminDashboard from "@/pages/admin/Dashboard";
import Countries from "@/pages/admin/Countries";
import Centers from "@/pages/admin/Centers";
import Projects from "@/pages/admin/Projects";
import Employees from "@/pages/admin/Employees";
import EmployeeDetail from "@/pages/admin/EmployeeDetail";
import EmployeeReport from "@/pages/admin/EmployeeReport";
import Attendance from "@/pages/admin/Attendance";
import AttendanceMatrix from "@/pages/admin/AttendanceMatrix";
import AdminTracking from "@/pages/admin/Tracking";
import Reports from "@/pages/admin/Reports";
import Policies from "@/pages/admin/Policies";
import Integrations from "@/pages/admin/Integrations";
import Corrections from "@/pages/admin/Corrections";
import Audit from "@/pages/admin/Audit";

import EmployeeDashboard from "@/pages/employee/Dashboard";
import EmployeeHistory from "@/pages/employee/History";
import EmployeeNotifications from "@/pages/employee/Notifications";

import "@/App.css";

function Root() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "employee" ? "/employee" : "/admin"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute roles={["super_admin", "center_admin"]}>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="attendance-matrix" element={<AttendanceMatrix />} />
            <Route path="tracking" element={<AdminTracking />} />
            <Route path="corrections" element={<Corrections />} />
            <Route path="reports" element={<Reports />} />
            <Route path="employees" element={<Employees />} />
            <Route path="employees/:id" element={<EmployeeDetail />} />
            <Route path="employees/:id/report" element={<EmployeeReport />} />
            <Route path="centers" element={<Centers />} />
            <Route path="countries" element={<Countries />} />
            <Route path="projects" element={<Projects />} />
            <Route path="policies" element={<Policies />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="audit" element={<Audit />} />
          </Route>

          <Route
            path="/employee"
            element={
              <ProtectedRoute roles={["employee", "center_admin"]}>
                <EmployeeLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<EmployeeDashboard />} />
            <Route path="history" element={<EmployeeHistory />} />
            <Route path="notifications" element={<EmployeeNotifications />} />
          </Route>

          <Route path="/" element={<Root />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors duration={2500} />
    </AuthProvider>
  );
}

export default App;
